<template lang="pug">
footer(:class="currentPath")
  .container.text-center
    p {{'FOOTER_COPYRIGHT' | wordDict}}
      |  |
      a(href="/disclaimer") {{'MENU_DISCLAIMER' | wordDict}}
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    currentPath() {
      return this.$route.path.split('/')[1]
    },
  },
  ready () {},
  attached () {},
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped>
footer {
  .container {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  p {
    margin-bottom: 0;
  }
  a {
    display: inline-block;
    margin-left: 5px;
  }
  &.login {
    @media (max-width: 767px) {
      font-size: 12px
    }
    &, a { color: white; }
    .container { background: transparent; }
  }
}
</style>



// WEBPACK FOOTER //
// footer.vue?fa93943e